import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Products from "@/components/site/Products";
import Industries from "@/components/site/Industries";
import Stats from "@/components/site/Stats";
import Facility from "@/components/site/Facility";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.25,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.2,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App grain">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Products />
        <Industries />
        <Stats />
        <Facility />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
